import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';

import {AuthService} from './auth.service';
import {ConfigService} from './config.service';
import {LogService} from './log.service';


@Injectable()
export class OrganizationService {
	constructor(
		private http: Http,
		private authService: AuthService,
		private config: ConfigService,
		private log: LogService
	) {}


	getOrganizations() {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			this.http.get(this.config.basePath + '/v0/organizations', options)
				.toPromise()
				.then( (res) => {
					resolve(res.json());
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}


	getOrganization(organizationId: string) {
		return new Promise( (resolve, reject) => {

			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			let options = new RequestOptions({ headers: headers });

			let userId = this.authService.userId;
			this.http.get(this.config.basePath + '/v0/organizations/' + organizationId, options)
				.toPromise()
				.then( (res) => {
					resolve(res.json());
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
// !!! TODO - make sure should reject, then fix everywhere!!!
					reject(err);
				});
		});
	}


	updateOrganization(organizationId: any, payload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.put(this.config.basePath + '/v0/organizations/' + organizationId, body, options)
				.toPromise()
				.then((res) => {
// console.log('res');
// console.log(res);
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});
	}


	createOrganization(payload: any) {
		return new Promise( (resolve, reject) => {
			let accessToken = localStorage.getItem('auth-jwt');
			let headers = new Headers({'Authorization': 'Bearer ' + accessToken});
			headers.append('Content-Type', 'application/json');
			let options = new RequestOptions({ headers: headers });

			let body = JSON.stringify(payload);

			this.http.post(this.config.basePath + '/v0/organizations', body, options)
				.toPromise()
				.then((res) => {
// console.log('res');
// console.log(res);
					resolve();
				})
				.catch((err) => {			// this is a Response object, with res.status === 401, for example
					this.log.error(err);
				});
		});

	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/organization.service.ts